/* eslint-disable operator-linebreak */
/* eslint-disable indent */
/* eslint-disable object-curly-spacing */
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from '../pages/user/Home';
import PaymentQR from '../pages/user/PaymentQR';
import PostPayment from '../pages/user/PostPayment';
import OrderHistory from '../pages/user/OrderHistory';
import TempClose from '../pages/user/TempClose';
import { useEffect, useState } from 'react';
import sls from 'react-secure-storage';

import '../styles/user/main.scss';
import { trackPromise } from 'react-promise-tracker';
import {
  setAppLanguage,
  setDisableTPPPApp,
  setDisableTPPPAppEndDate,
  setDisableTPPPTempClose,
  setFullLoading,
} from '../store/appSlice';
import { apiGet, apiPost } from '../apis';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentLanguage } from '../helpers/language-switcher';
import { useMsal } from '@azure/msal-react';
import maintenanceAnimation from '../assets/images/maintenance-animation.json';
import Lottie from 'lottie-react';
import { language } from '../language';
import moment from 'moment';

import '../styles/fonts.scss';
import { formatDateTime } from '../helpers/datetime';
import LastDateBuyBanner from '../components/user/LastDateBuyBanner';

export const UserRoutes = (props) => {
  const { instance, accounts } = useMsal();
  const [encryptedData, setEncryptedData] = useState();
  const dispatch = useDispatch();
  const hrMobileLanguage = useSelector(
    (state) => state.app.slsHrMobileLanguage,
  );
  const isToDisableTPPPApp = useSelector(
    (state) => state.app.isToDisableTPPPApp,
  );
  const disableTPPPAppEndDate = useSelector(
    (state) => state.app.disableTPPPAppEndDate,
  );
  const disableTPPPTempClose = useSelector(
    (state) => state.app.disableTPPPTempClose,
  );
  useEffect(() => {
    const lang = getCurrentLanguage();

    sls.setItem('slsHrMobileLanguage', lang);
    dispatch(setAppLanguage(lang));
  }, [dispatch]);

  const callUerProfileApi = async () => {
    trackPromise(
      (async () => {
        try {
          dispatch(setFullLoading(true));
          const res = await apiGet({
            uri: `TimeInOut/GetUserInfo?emailOrId=${accounts[0]?.username}`,
            msal: {
              instance: instance,
              accounts: accounts,
            },
            callHrMobile: true,
            useHrMobileSecondaryApi: true,
          });

          if (res) {
            const fullEmpInfo = await apiGet({
              uri: `Employee/GetUserInfoEpp?employeeId=${res?.employeeId}`,
              msal: {
                instance: instance,
                accounts: accounts,
              },
              callHrMobile: true,
              useHrMobileSecondaryApi: true,
            });

            const empData = {
              authUser: { ...res, ...fullEmpInfo },
            };
            sls.setItem('slsHrMobileData', empData);
            setEncryptedData(empData);
          }

          dispatch(setFullLoading(false));
        } catch (error) {
          dispatch(setFullLoading(true));
          console.error(error);
        }
      })(),
    );
  };

  useEffect(() => {
    (async () => {
      try {
        await callUerProfileApi();
      } catch (error) {
        dispatch(setFullLoading(true));
        console.error(error);

        return false;
      }
    })();
  }, []);

  // START: display maintenance page logic
  const [displayMaintenanceAni, setDisplayMaintenanceAni] = useState(false);
  const checkInterval = 1000 * 5;

  const checkMaintenancePeriod = () => {
    let isMaintenancePeriod = false;
    const format = 'hh:mm:ss';
    const currentTime = moment(new Date(), format);
    const beforeTime = moment('01:00:00', format);
    const afterTime = moment('03:00:00', format);

    if (currentTime.isBetween(beforeTime, afterTime)) {
      isMaintenancePeriod = true;
    } else {
      isMaintenancePeriod = false;
    }

    return isMaintenancePeriod;
  };

  const checkDisableTPPPApp = (res) => {
    let isDisable = false;
    const currentTime = moment(new Date());
    const beforeTime = moment(res?.disableModeStart);
    const afterTime = moment(res?.disableModeEnd);

    if (currentTime.isBetween(beforeTime, afterTime)) {
      isDisable = true;
    } else {
      isDisable = false;
    }

    return isDisable;
  };

  const checkServerMaintenance = async () => {
    (async () => {
      try {
        const isMaintenancePeriod = checkMaintenancePeriod();
        const res = await apiGet({
          uri: `Maintainance/Status`,
          msal: {
            instance: instance,
            accounts: accounts,
          },
          displayCustomError: true,
        });

        if (!res) return;

        const isToDisableTPPPApp = checkDisableTPPPApp(res);
        dispatch(
          setDisableTPPPAppEndDate(
            res?.disableModeEnd
              ? formatDateTime({
                  dateTime: res?.disableModeEnd,
                  dateOnly: true,
                  convertToThai: hrMobileLanguage == 'en' ? false : true,
                })
              : '',
          ),
        );
        dispatch(setDisableTPPPApp(isToDisableTPPPApp));

        // START: check EmpClose status
        const empCloseRes = await apiGet({
          uri: `Maintainance/EmpCloseStatus`,
          msal: {
            instance: instance,
            accounts: accounts,
          },
          displayCustomError: true,
        });
        dispatch(setDisableTPPPTempClose(!!empCloseRes?.empCloseMode));
        // END: check EmpClose status

        setDisplayMaintenanceAni(
          isMaintenancePeriod ? isMaintenancePeriod : res?.maintainanceMode,
        );
      } catch (error) {
        dispatch(setDisableTPPPApp(true));
        console.error(error);
      }
    })();
  };

  useEffect(() => {
    (async () => {
      // if (process.env.REACT_APP_ENV == 'local') return;

      // auto check
      await checkServerMaintenance();

      const interval = setInterval(async () => {
        await checkServerMaintenance();
      }, checkInterval);
      return () => clearInterval(interval);
    })();
  }, []);

  if (displayMaintenanceAni) {
    return (
      <div className="container">
        <div className="maintenance-page text-center fw-bold text-nowrap text-secondary">
          <Lottie
            animationData={maintenanceAnimation}
            speed={10}
            loop={true}
            style={{ maxWidth: '430px' }}
          />
          <p className="">
            {language?.maintenanceMsg?.firstLine?.[hrMobileLanguage]}
          </p>
          <p className="">
            {language?.maintenanceMsg?.secondLine?.[hrMobileLanguage]}
          </p>

          <div
            className={`p-2 mt-4 bg-black float-box-shadow rounded w-25`}
            style={{ cursor: 'pointer' }}
            onClick={async () =>
              (window.location.href = process.env.REACT_APP_HR_MOBILE_URL)
            }
          >
            <span className="text-white">
              {language?.close?.[hrMobileLanguage]}
            </span>
          </div>
        </div>
      </div>
    );
  }
  // END: display maintenance page logic

  // START: display EmpClose page
  if (disableTPPPTempClose) {
    return (
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <TempClose />
      </BrowserRouter>
    );
  }
  // END: display EmpClose page

  if (!encryptedData) {
    return <></>;
  }

  return (
    <div className="container-fluid user-app p-0 px-2">
      {isToDisableTPPPApp && (
        <div
          style={{
            position: 'sticky',
            top: 0,
            background: 'white',
            zIndex: 6,
            marginTop: '-8px',
          }}
        >
          <div
            className="text-center py-3 border-bottom"
            style={{
              overflowX: 'scroll',
              whiteSpace: 'nowrap',
              backgroundColor: '#f97c89',
              marginLeft: '-10px',
              marginRight: '-10px',
              color: '#ffffff',
              padding: '0 16px',
            }}
          >
            {language?.disableTPPPAppMsg?.firstLine?.[hrMobileLanguage] +
              disableTPPPAppEndDate}
          </div>
        </div>
      )}

      <LastDateBuyBanner />

      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/order/qr-payment" element={
            <PaymentQR />
          } />
          <Route path="/order/post-payment" element={
            <PostPayment />
          } />
          <Route path="/order-histories" element={
            <OrderHistory />
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
};
